import { sagaCreator } from '@adrias-online/steiner/lib/helpers';

import helper from '../../../helpers/steinerHelper';
import { actions, actionTypes } from '../actions/funnel';
import { selectors, DEFAULT_STATE } from '../reducers/funnel';
import api from '../apis/funnel';

const sagas = helper.createSagas(
    'funnel',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
